import connectivityService from './device/connectivityService';
import {getIqosService} from './device/iqosServiceClient';
import {log} from './log.js';

export const connectToUSB = async ({isNewDevice, onDeviceSelect, onDeviceInitialization, onError, isReconnect}) => {
    connectivityService.setIsUsb();
    console.log('Connecting to USB device...');

    try {
        const iqosServiceClient = getIqosService();
        await iqosServiceClient.connect({isNewDevice, onDeviceSelect, onDeviceInitialization, isReconnect});
    } catch (e) {
        log.info(`connectToUSB: device connection failed, error: ${e}`);

        onError?.(e);
    }
};
